import React from 'react';

const AboutPageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/about',
			exact: true,
			component: React.lazy(() => import('./AboutPage')),
		},
	],
};

export default AboutPageConfig;
